/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { ExtensionContext, l10n, workspace } from 'vscode';
import { $Vlc, IDisposable } from './util';

export interface ITerminalEnvironmentProvider {
	featureDescription?: string;
	getTerminalEnv(): { [key: string]: string };
}

export class $Bmc {

	private readonly a: IDisposable;

	constructor(private readonly b: ExtensionContext, private readonly c: (ITerminalEnvironmentProvider | undefined)[]) {
		this.a = $Vlc(workspace.onDidChangeConfiguration, e => e.affectsConfiguration('git'))
			(this.d, this);

		this.d();
	}

	private d(): void {
		const config = workspace.getConfiguration('git', null);
		this.b.environmentVariableCollection.clear();

		if (!config.get<boolean>('enabled', true)) {
			return;
		}

		const features: string[] = [];
		for (const envProvider of this.c) {
			const terminalEnv = envProvider?.getTerminalEnv() ?? {};

			for (const name of Object.keys(terminalEnv)) {
				this.b.environmentVariableCollection.replace(name, terminalEnv[name]);
			}
			if (envProvider?.featureDescription && Object.keys(terminalEnv).length > 0) {
				features.push(envProvider.featureDescription);
			}
		}
		if (features.length) {
			this.b.environmentVariableCollection.description = l10n.t('Enables the following features: {0}', features.join(', '));
		}
	}

	dispose(): void {
		this.a.dispose();
	}
}
